module.exports = __webpack_public_path__ + "img/chair-banner.7f842981.webp";